import React, { useEffect } from "react";

/** @jsx jsx */
import { jsx, css, keyframes } from '@emotion/react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { InfoLevel } from "../types/uiTypes";
import { Colors } from "../palettes/colorPalette";
import { backgroundTexture } from "../uiConstants";

interface UIInfoProps {
    level: InfoLevel,
    text: string,
    shouldTimeout: boolean,
    setText: (text: string) => void
}

const containerStyle = css`
    width: fit-content;
    padding: 2vh;
	background: url(${backgroundTexture});
    background-color: ${Colors.UIBackground};
    font-family: NotoSans;
    border-radius: 1vw;
    border: 0.25vh solid ${Colors.UITextAndBorders};
    opacity: 1;
`;

const infoStyle = css`
    width: fit-content;
    padding: 2vh;
	background: url(${backgroundTexture});
    background-color: ${Colors.UIBackground};
    font-family: NotoSans;
    border-radius: 1vw;
    border: 0.25vh solid ${Colors.UITextAndBorders};
    opacity: 1;
`;

const textStyle = css`
    margin-left: 8px;
`;

const keys = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const pulse = css`
	animation: ${keys} 3s cubic-bezier(1.000, 0.000, 0.970, 0.065);
`;

export const UIInfo = (props: UIInfoProps) => {
    React.useEffect(() => {
        const el = document.getElementById(`uiinfo_${props.level}`);
        const listener = el?.addEventListener('animationend', () => {
            if (props.shouldTimeout) {
                props.setText('');
            }
            //setShow(false);
        });
        return () => {
            el?.removeEventListener('animationend', listener as any);
        }
    }, [props.level, props.setText]);

    return (
        <>
            {
                props.text !== '' &&
                <div id={`uiinfo_${props.level}`} css={css`
                ${props.level === 'Info' ? infoStyle : containerStyle}
                ${pulse}
            `}>
                    <FontAwesomeIcon icon={props.level === 'Info' ? faInfoCircle : faExclamationTriangle} />
                    <span css={textStyle}>{props.text}</span>
                </div>
            }
        </>
    )
};
